import { Injectable } from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {TranslocoService} from "@jsverse/transloco";
import {IndividualConfig} from "ngx-toastr/toastr/toastr-config";

@Injectable({
  providedIn: 'root'
})
export class LeToastrService {

  constructor(private toastrService: ToastrService, private translocoService: TranslocoService) { }

  translatedError(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.translocoService.selectTranslate([message, title]).subscribe(([translatedMessage, translatedTitle]) => {
      this.toastrService.error(translatedMessage, translatedTitle, override);
    });
  }

  translatedWarning(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.translocoService.selectTranslate([message, title]).subscribe(([translatedMessage, translatedTitle]) => {
      this.toastrService.warning(translatedMessage, translatedTitle, override);
    });
  }

  translatedSuccess(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.translocoService.selectTranslate([message, title]).subscribe(([translatedMessage, translatedTitle]) => {
      this.toastrService.success(translatedMessage, translatedTitle, override);
    });
  }

  success(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastrService.success(message, title, override);
  }
  error(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastrService.error(message, title, override);
  }
  warning(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastrService.warning(message, title, override);
  }
}
